export default __webpack_public_path__ + "static/media/popup_eos.4704106c.png";